import React, { useEffect } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import { makeStyles, CircularProgress } from '@material-ui/core'
import { withRouter } from 'react-router-dom'

const useStyles = makeStyles(theme => ({
  title: {
    textAlign: 'center'
  },
  progress: {
    margin: theme.spacing(2),
  }
}))

function RedirectDialog(props) {

  const { open, close, handleGoToRedirect } = props

  const classes = useStyles()


  useEffect(() => {
    if(open){
      setTimeout(() => {
        handleGoToRedirect()
      }, 3000)
    }
      
    // eslint-disable-next-line
    }, [open])


  return (
    <Dialog
      fullWidth
      maxWidth={'sm'}
      open={open}
      onClose={close}>
      <DialogContent>
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            You will be redirected soon...
          <CircularProgress className={classes.progress} />
        </div>
          
      </DialogContent>
    </Dialog>
  )
}


export default withRouter(RedirectDialog)
